import {
  getObjectUtil,
  formatDateUtil,
  setUtil
} from 'packages/src'
import { EXERCISE_LOG_KEY } from '../../constants'
import getInstanceReduxUtil from '../../../../redux/utils/get-instance'
import {
  getIdReduxUtil,
  getValueReduxUtil
} from '../../../../redux'
import {
  EXERCISES_ACTIVITY_UI_TAB,
  EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_FORMAT,
  EXERCISES_ACTIVITY_UI_TAB_TO_PATH
} from '../../../../exercises-activity-ui'
import { deleteInstanceFromDateMapsReduxUtil } from '../../../../redux/utils/delete-instance-from-date-maps'
import { addInstanceToDateMapsReduxUtil } from '../../../../redux/utils/add-instance-to-date-maps'
import { EXERCISE_LOGS_PATH } from '../../../../exercise-logs'

function deleteExerciseLogFromActivityDomain (state, instance) {
  instance = getInstanceReduxUtil(state, instance)
  const exerciseId = getValueReduxUtil(instance, EXERCISE_LOG_KEY.EXERCISE_ID)
  const loggedAt = getValueReduxUtil(instance, EXERCISE_LOG_KEY.LOGGED_AT)

  const dateStringWeek = formatDateUtil(
    new Date(loggedAt),
    EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_FORMAT[EXERCISES_ACTIVITY_UI_TAB.WEEK]
  )
  state = deleteInstanceFromDateMapsReduxUtil({
    state,
    instance,
    dateString: dateStringWeek,
    dateMapPath: EXERCISES_ACTIVITY_UI_TAB_TO_PATH[EXERCISES_ACTIVITY_UI_TAB.WEEK],
    suffixKey: exerciseId
  })

  const dateStringMonth = formatDateUtil(
    new Date(loggedAt),
    EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_FORMAT[EXERCISES_ACTIVITY_UI_TAB.MONTH]
  )
  state = deleteInstanceFromDateMapsReduxUtil({
    state,
    instance,
    dateString: dateStringMonth,
    dateMapPath: EXERCISES_ACTIVITY_UI_TAB_TO_PATH[EXERCISES_ACTIVITY_UI_TAB.MONTH],
    suffixKey: exerciseId
  })

  const dateStringYear = formatDateUtil(
    new Date(loggedAt),
    EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_FORMAT[EXERCISES_ACTIVITY_UI_TAB.YEAR]
  )
  state = deleteInstanceFromDateMapsReduxUtil({
    state,
    instance,
    dateString: dateStringYear,
    dateMapPath: EXERCISES_ACTIVITY_UI_TAB_TO_PATH[EXERCISES_ACTIVITY_UI_TAB.YEAR],
    suffixKey: exerciseId
  })

  return state
}

function addExerciseLogToActivityDomain (state, instance) {
  instance = getInstanceReduxUtil(state, instance)
  const exerciseId = getValueReduxUtil(instance, EXERCISE_LOG_KEY.EXERCISE_ID)
  const loggedAt = getValueReduxUtil(instance, EXERCISE_LOG_KEY.LOGGED_AT)

  const dateStringWeek = formatDateUtil(
    new Date(loggedAt),
    EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_FORMAT[EXERCISES_ACTIVITY_UI_TAB.WEEK]
  )
  state = addInstanceToDateMapsReduxUtil({
    state,
    instance,
    dateString: dateStringWeek,
    dateMapPath: EXERCISES_ACTIVITY_UI_TAB_TO_PATH[EXERCISES_ACTIVITY_UI_TAB.WEEK],
    suffixKey: exerciseId
  })

  const dateStringMonth = formatDateUtil(
    new Date(loggedAt),
    EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_FORMAT[EXERCISES_ACTIVITY_UI_TAB.MONTH]
  )
  state = addInstanceToDateMapsReduxUtil({
    state,
    instance,
    dateString: dateStringMonth,
    dateMapPath: EXERCISES_ACTIVITY_UI_TAB_TO_PATH[EXERCISES_ACTIVITY_UI_TAB.MONTH],
    suffixKey: exerciseId
  })

  const dateStringYear = formatDateUtil(
    new Date(loggedAt),
    EXERCISES_ACTIVITY_UI_TAB_TO_DATE_STRING_FORMAT[EXERCISES_ACTIVITY_UI_TAB.YEAR]
  )
  state = addInstanceToDateMapsReduxUtil({
    state,
    instance,
    dateString: dateStringYear,
    dateMapPath: EXERCISES_ACTIVITY_UI_TAB_TO_PATH[EXERCISES_ACTIVITY_UI_TAB.YEAR],
    suffixKey: exerciseId
  })

  return state
}

function addToExerciseIdMap (state, instance) {
  const exerciseId = getValueReduxUtil(instance, EXERCISE_LOG_KEY.EXERCISE_ID)
  let domainList = getObjectUtil(state,
    `${EXERCISE_LOGS_PATH.EXERCISE_ID_MAP}.${exerciseId}`
  )
  if (!domainList) {
    domainList = []
  }
  domainList = [
    ...domainList,
    getIdReduxUtil(instance)
  ]
  return setUtil(state,
    `${EXERCISE_LOGS_PATH.EXERCISE_ID_MAP}.${exerciseId}`,
    domainList
  )
}

function afterCreateExerciseLogHook (instance, state) {
  state = addExerciseLogToActivityDomain(state, instance)
  state = addToExerciseIdMap(state, instance)
  return state
}

export {
  afterCreateExerciseLogHook,
  deleteExerciseLogFromActivityDomain
}
